import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { createXlsxDetail } from "./detail";

export async function generateFile({
  reportData = [],
  optionData = {},
  finishAction = () => {},
} = {}) {
  const workbook = new ExcelJS.Workbook();

  let treatmentData = reportData
      .filter((item) => item.question.type === 1)
      .map((item, index) => ({
        ...item,
        member: {
          ...item.member,
          serial: index + 1,
        },
      })),
    controlData = reportData
      .filter((item) => item.question.type === 2)
      .map((item, index) => ({
        ...item,
        member: {
          ...item.member,
          serial: index + 1,
        },
      }));

  if (treatmentData.length > 0) {
    createXlsxDetail({
      title: "近視治療",
      data: {
        workbook,
        reportType: "treatment",
        reportData: treatmentData,
        optionData,
      },
    });
  }
  if (controlData.length > 0) {
    createXlsxDetail({
      title: "光學控制",
      data: {
        workbook,
        reportType: "control",
        reportData: controlData,
        optionData,
      },
    });
  }

  // 清冊範例 excel
  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });

  saveAs(mainBlob, `報表.xlsx`);
  finishAction();
}
